// extracted by mini-css-extract-plugin
export default {"root":"References--root--1rQFo","previewList":"References--previewList--Y6go8","item":"References--item--SZ19u","subheadline":"References--subheadline--1zE4P"};